<template>
  <div id="app0" @click="closeSearchPage"  @mousedown="whichButton($event)">
<!--    <img src="./assets/logo.png">-->
    <div v-if="showIndex">
      <router-view name="head"></router-view>
      <router-view name="content"></router-view>
      <router-view name="footer"></router-view>
      <router-view></router-view>
      <router-view name="audioPlayer" ref="audioPlayerPage"></router-view>
    </div>
    <div v-if="showLoad" style="width: 100vh;height: 100vh;">
      <div class="none">网站建设中。。。</div>
    </div>

  </div>
</template>

<script type="es6">
  import {mapGetters} from 'vuex'
  import {
    getUserDetail,
    getUserIp,
    logoutTime,
    sensitiveWords,
    siteSwitch,
    userDevice,
    userOperation
  } from "./config/axiosUtil";
  import $ from "jquery";
  import {Message} from "element-ui";
  import LoginPage from "../src/components/loginPage";
  import vConsole from "vconsole";
  // import {checkSensitiveWord} from "../static/js/DFA";
  export default {

  name: 'App',
  data(){
    return{
      showLogin: false,
      showLoad: false,
      showIndex: true,
    }
  },
  computed: {
    ...mapGetters({
      userInfo: 'userInfo'
    })
  },
  created() {
    // 注册页面监听器
    document.addEventListener("visibilitychange", this.visibilitychangeFn);
    this.getSiteSwitch()
  },
  mounted() {
    // new vConsole()
    console.log(this.$route.name)
    if(this.$route.path && this.$route.path.indexOf('app/') === -1){
    this.onScroll()
    // this.mapZoom()
    this.timerInterval()
    this.getSensitiveWords()
    this.getSiteSwitch()
    }
  },
  methods: {
    timerInterval(){
      let that = this
      if(!this.userInfo.userid) return;
      let i=0
      let timer = setInterval(()=>{
        i++
        function changeTime(){
          let lastTime = localStorage.getItem('lastPost') || null
          let nowTime = Date.now()
          if (!lastTime){
            localStorage.setItem('lastPost', nowTime)
            lastTime = nowTime
          }
          if(i%30===0){
            let params = new FormData()
            params.append('types', 'update')
            params.append('lastTime', lastTime)
            userDevice(params).then(response=>{
            }).catch(err=>{
            })
          }
          let logOutTime = localStorage.getItem('logout-time') || 30
          if(nowTime - Number(lastTime)>= (Number(logOutTime)*60*1000)){
            if (localStorage.getItem('iiucasToken')){
              //  退出
              clearInterval(timer)
              let params = new FormData()
              params.append('types', 'logout')
              params.append('token', localStorage.getItem('iiucasToken'))
              userDevice(params).then(response=>{
                localStorage.removeItem('lastPost')
                localStorage.removeItem('iiucasToken')
                localStorage.removeItem('userInfo')

              }).catch(err=>{

              })

            }
          }
        }
        changeTime()
      }, 1000*60)
    },
    visibilitychangeFn () {
      if (!document.hidden) {
        //处于当前页面
        console.log('进入页面', Date.now());
        getUserDetail({types: 'new'}).then(data=>{
          if(data.data.data.user){
            localStorage.setItem('userInfo',JSON.stringify(data.data.data))
            this.$store.dispatch('setInfo')
          } else {
            localStorage.removeItem('userInfo')
            this.$store.dispatch('setInfo')
          }
        }).catch(err=>{
          console.log(err)
        })
        getUserIp().then(data=>{

        }).catch(err=>{
          console.log(err)
        })
      } else {
        console.log('离开页面');
        if(this.$route.name === 'video' || this.$route.name === 'series' || this.$route.name === 'interactive'){
          let params = new FormData()
          params.append('id', this.$route.params.BVID)
          params.append('types', '观看视频')
          params.append('lastTime', Date.now())
          params.append('times', localStorage.getItem('videoLookTime') || '')
          userOperation(params).then(data=>{}).catch(err=>{})
        }else if(this.$route.name === 'audio' || this.$route.name === 'audioCollect'){
          let params = new FormData()
          if(this.$route.name==='audio'){
            params.append('id', this.$route.params.AUID)
          }else {
            params.append('id', this.$route.params.AMID)
          }
          params.append('types', '播放音频')
          params.append('lastTime', Date.now())
          params.append('times', localStorage.getItem('audioLookTime') || '')
          userOperation(params).then(data=>{}).catch(err=>{})
        }else if(this.$route.name === 'article'){
          let params = new FormData()
          params.append('id', this.$route.params.CVID)
          params.append('types', '阅读文章')
          params.append('lastTime', Date.now())
          params.append('times', localStorage.getItem('articleLookTime') || '')
          userOperation(params).then(data=>{}).catch(err=>{})
        }
      }
    },
    closeSearchPage(){
      // console.log('close')
      $('.header-search-suggest').css({'display': 'none'})
    },
    whichButton(event){

    var btnNum=event.button;

    if(btnNum===2){

      // console.log("您点击了鼠标右键！")

    }else if(btnNum===0){

      // console.log("您点击了鼠标左键！")

    }else if(btnNum===1){

      // console.log("您点击了鼠标中键！");
      event.target.click()

    }else{

      // console.log("您点击了"+btnNum+"号键，我不能确定它的名称。");

    }

  },
    onScroll(){
      let that = this
      logoutTime({name: '优卡思'}).then(data=>{
        if(data.data[0]){
          localStorage.setItem('logout-time', data.data[0].time)
        }else {
          localStorage.setItem('logout-time', 30)
        }
      }).catch(err=> console.log(err))
      window.addEventListener('scroll', function (){
        changeTime()
      })
      document.addEventListener('keyup', function (){
        changeTime()
      })
      document.addEventListener('mouseup', function (){
        changeTime()
      })
      document.addEventListener('mousemove', function (){
        changeTime()
      })
      // window.onscroll = function (){
      //   changeTime()
      // }
      // document.onkeyup = function (){
      //   changeTime()
      // }
      // document.onmouseup = function (){
      //   changeTime()
      // }
      // document.onmousemove = function (){
      //   changeTime()
      // }
      function changeTime(){
        let lastTime = localStorage.getItem('lastPost') || null
        let nowTime = Date.now()
        if (!lastTime){
          localStorage.setItem('lastPost', nowTime)
          lastTime = nowTime
        }
        let logOutTime = localStorage.getItem('logout-time') || 30
        if(nowTime - Number(lastTime)>= (Number(logOutTime)*60*1000)){
          if (localStorage.getItem('iiucasToken')){
            //  退出
            let params = new FormData()
            params.append('types', 'logout')
            params.append('token', localStorage.getItem('iiucasToken'))
            userDevice(params).then(response=>{
              localStorage.removeItem('lastPost')
              localStorage.removeItem('iiucasToken')
              localStorage.removeItem('userInfo')
              Message.warning('登录超时')
              location.reload()
            }).catch(err=>{

            })

          }
        }else {
          localStorage.setItem('lastPost', nowTime)
        }
      }
    },
    mapZoom(){
      var paramNumber = 1
      const keyCodeMap = {
        // 91: true, // command
        61: true,
        107: true, // 数字键盘 +
        109: true, // 数字键盘 -
        173: true, // 火狐 - 号
        187: true, // +
        189: true, // -
      };
      // 覆盖[ctrl]command + [+]/[-]
      document.onkeydown = function (event) {
        //ratio = window.outerWidth / window.innerWidth;
        const e = event || window.event;
        const ctrlKey = e.ctrlKey || e.metaKey;
        console.log(e.keyCode)
        if (ctrlKey && keyCodeMap[e.keyCode]) {
          e.preventDefault();

          // paramNumber += 0.1
          // document.getElementsByTagName('body')[0].style.zoom=paramNumber;
        } else if (e.detail) { // Firefox
          event.returnValue = false;

          // paramNumber += 0.1
          // document.getElementsByTagName('body')[0].style.zoom=paramNumber;
        }

      };

      // // 覆盖鼠标滚轮
      // document.addEventListener('wheel', (e) => {
      //   if (e.ctrlKey|| e.metaKey) {
      //     if (e.deltaY < 0) {
      //       console.log(e)
      //       document.getElementsByTagName('body')[0].style.zoom=2;
      //       e.preventDefault();
      //       return false;
      //     }
      //     if (e.deltaY > 0) {
      //       console.log(e)
      //       document.getElementsByTagName('body')[0].style.zoom=1;
      //       e.preventDefault();
      //       return false;
      //     }
      //   }
      // }, { passive: false });
    },
    getSensitiveWords(){
      sensitiveWords().then(data=>{
        sessionStorage.setItem('keywords', JSON.stringify(data.data))
        // let a = checkSensitiveWord('发售B样a片')
      }).catch(err=>{

      })

    },
    getSiteSwitch(){
      siteSwitch().then(data=>{
        if((data.data.length===0 || !data.data[0].switch) && this.$route.name === 'index'){
          this.showLoad = true
          this.showIndex = false
        } else {
          this.showIndex = true
        }
      }).catch(err=>{
        this.showLoad = true
      })
    },
  },
    destroyed() {
      document.removeEventListener('visibilitychange', this.visibilitychangeFn)
    },
    components: {
    LoginPage,
  },
}
</script>

<style>
#app0 {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
  font-size: 12px;
  /*margin-top: 60px;*/

}
*{
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  /*cursor: pointer;*/
  user-select: none;
}
  li {
    list-style: none;
  }
  a:link, a:hover{
    text-decoration: none;
    outline: none;
  }
  a {
    color: #212121;
    transition: color .3s;
  }
  .text a {
    color: #00a1d6;
    cursor: pointer;
  }
  a:hover {
    color: #00a1d6;
  }
  input, select {
    outline: none;
  }
  input, textarea {
    -webkit-user-select: text;
    line-height: normal!important;
  }
::-webkit-scrollbar{
  width: 8px;
  height: 8px;
}
::-webkit-scrollbar-thumb {
  background: #ccd0d7;
  border-radius: 4px;
}
::-webkit-input-placeholder{
  color: #99a2aa;
}
.left {
  float: left;
}
.right {
  float: right;
}
.clearfix:after, .clearfix:before {
  content: " ";
  display: table;
}
.clearfix:after {
  clear: both;
}
div[contenteditable='true']{
  -webkit-user-select: text;
}
.none {
  left: 50%;
  position: absolute;
  top: 30%;
  font-size: xx-large;
  transform: translate(-50%, 0);
}
</style>



// WEBPACK FOOTER //
// src/App.vue